/* PT · Header (spec-nav-menu-1a1b) — desktop panels (click + hover-intent,
   one at a time, Esc / outside click / focus-out close), region popover,
   shop-by-phone columns from the fit database, and the one-level mobile
   sheet (pinned header/footer, brand pills with a 160ms cross-fade, overlay /
   back / swipe dismissal). Theme Editor: re-inits on section load. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var MODELS = null, LOADING = null;

  function cfg() { try { return JSON.parse((document.getElementById("pt-hdr-data") || {}).textContent || "{}"); } catch (e) { return {}; } }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }

  /* ---- fit database: same file as the matcher; cached per session ---- */
  function loadModels(cb) {
    if (MODELS) { cb(MODELS); return; }
    if (LOADING) { LOADING.push(cb); return; }
    LOADING = [cb];
    var done = function (list) {
      MODELS = (list || []).map(function (m) {
        var name = (m.brand ? m.brand + " " + m.model : m.model);
        return { id: m.id, brand: String(m.brand || ""), model: String(m.model || ""), name: name, rank: m.rank == null ? 9999 : m.rank, fit: m.fit, search: (m.aliases || []).concat([String(name).toLowerCase()]) };
      }).sort(function (a, b) { return a.rank - b.rank; });
      var q = LOADING; LOADING = null; q.forEach(function (f) { f(MODELS); });
    };
    var url = cfg().fitDbUrl; if (!url) { done([]); return; }
    try { var c = sessionStorage.getItem("pt-hdr-fitdb"); if (c) { done(JSON.parse(c)); return; } } catch (e) {}
    var hour = Math.floor(Date.now() / 3600000);
    fetch(url + (url.indexOf("?") === -1 ? "?v=h" : "&v=h") + hour).then(function (r) { return r.json(); }).then(function (j) {
      var list = j.models || j; try { sessionStorage.setItem("pt-hdr-fitdb", JSON.stringify(list)); } catch (e) {}
      done(list);
    }).catch(function () { done([]); });
  }
  function pick(list, brand, n) {
    var c = cfg(), words = String(c.foldableHint || "fold, flip, razr, open").split(",").map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
    var out;
    if (/^fold/i.test(brand)) {
      /* foldables across brands: at most two per brand so the column is not six
         Galaxy Z models in a row (round-robin by rank) */
      var all = list.filter(function (m) { var nm = m.name.toLowerCase(); return words.some(function (w) { return nm.indexOf(w) !== -1; }); });
      var perBrand = {}; out = [];
      all.forEach(function (m) { var b = m.brand.toLowerCase(); if ((perBrand[b] || 0) < 2) { perBrand[b] = (perBrand[b] || 0) + 1; out.push(m); } });
      if (out.length < n) all.forEach(function (m) { if (out.length < n && out.indexOf(m) === -1) out.push(m); });
    }
    else if (!brand) out = list;
    else out = list.filter(function (m) { return m.brand.toLowerCase() === brand.toLowerCase(); });
    return out.slice(0, n);
  }
  function modelLink(m) { return cfg().productUrl + "?model=" + encodeURIComponent(m.id || m.name); }
  /* brand-less display in a brand column ("iPhone 17 Pro", not "Apple iPhone 17 Pro") */
  function shortName(m, brand) { return (brand && !/^fold/i.test(brand)) ? m.model : m.name; }

  function init() {
    var hdr = document.getElementById("site-header");
    if (!hdr || !hdr.classList.contains("pt-hdr") || hdr.__ptInit) return;
    hdr.__ptInit = true;
    var c = cfg(), per = Number(c.perColumn) || 6;

    /* ---- desktop panels ---- */
    var items = [].slice.call(hdr.querySelectorAll(".pt-hdr-item[data-panel]"));
    var panels = {}; items.forEach(function (b) { panels[b.getAttribute("data-panel")] = document.getElementById(b.getAttribute("aria-controls")); });
    var openKey = null, hoverT = null, leaveT = null, openedBy = null, openedAt = 0;
    /* close with a short fade instead of vanishing (owner): the panel gets
       .pt-closing, plays the out animation, then goes hidden */
    function hideEl(el) {
      if (!el || el.hidden) return;
      if (reduced) { el.hidden = true; return; }
      el.classList.add("pt-closing");
      var done = function () { el.classList.remove("pt-closing"); el.hidden = true; el.removeEventListener("animationend", done); };
      el.addEventListener("animationend", done);
      setTimeout(done, 260);
    }
    function showEl(el) { if (!el) return; el.classList.remove("pt-closing"); el.hidden = false; }
    function setOpen(key, by) {
      if (openKey === key) return;
      openKey = key; openedBy = by || null; openedAt = Date.now();
      items.forEach(function (b) { var on = b.getAttribute("data-panel") === key; b.setAttribute("aria-expanded", on ? "true" : "false"); });
      Object.keys(panels).forEach(function (k) { if (!panels[k]) return; if (k === key) showEl(panels[k]); else hideEl(panels[k]); });
      if (key) closeRegion();
    }
    function closeAll() { setOpen(null); }
    items.forEach(function (b) {
      b.addEventListener("click", function () {
        clearTimeout(hoverT);
        var key = b.getAttribute("data-panel");
        /* A click on the item whose panel is already open keeps it open when the
           hover opened it (owner: hover → panel appears → click closed it again).
           Only a deliberate second click, on a panel the user opened by clicking,
           closes it; outside click / Esc / leaving the bar still close. */
        if (openKey === key) { if (openedBy === "click" && Date.now() - openedAt > 500) setOpen(null); else { openedBy = "click"; openedAt = Date.now(); } return; }
        setOpen(key, "click");
      });
      b.addEventListener("mouseenter", function () { clearTimeout(leaveT); clearTimeout(hoverT); hoverT = setTimeout(function () { setOpen(b.getAttribute("data-panel"), "hover"); }, 60); });
      b.addEventListener("mouseleave", function () { clearTimeout(hoverT); });
    });
    /* every link (logo, items, rows, pills): show the pressed state at once, the
       page may take a moment to arrive (owner: "there should always be a reaction") */
    function pressOn(root) {
      if (!root) return;
      root.addEventListener("click", function (e) {
        var a = e.target.closest && e.target.closest("a[href]"); if (!a || !root.contains(a)) return;
        var href = a.getAttribute("href") || ""; if (href.charAt(0) === "#" && href !== "#") return;
        a.classList.add("pt-pressed"); setTimeout(function () { a.classList.remove("pt-pressed"); }, 4000);
      });
    }
    pressOn(hdr); pressOn(document.getElementById("pt-mnav"));
    /* leave the bar + panel → close after a short grace */
    hdr.addEventListener("mouseleave", function () { leaveT = setTimeout(closeAll, 220); });
    hdr.addEventListener("mouseenter", function () { clearTimeout(leaveT); });
    document.addEventListener("click", function (e) { if (!hdr.contains(e.target)) { closeAll(); closeRegion(); } });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeAll(); closeRegion(); closeSheet(); } });
    /* focus leaving the header closes the panels (keyboard users), but a click on
       plain text inside a panel also moves focus to <body>; that is not leaving,
       so a pointer press inside the header suppresses the focus-out close */
    var pressInside = 0;
    hdr.addEventListener("pointerdown", function () { pressInside = Date.now(); });
    hdr.addEventListener("focusout", function (e) {
      if (e.relatedTarget && hdr.contains(e.relatedTarget)) return;
      setTimeout(function () { if (!hdr.contains(document.activeElement) && Date.now() - pressInside > 400) { closeAll(); closeRegion(); } }, 0);
    });

    /* ---- region popover (desktop) ---- */
    var rbtn = hdr.querySelector(".pt-hdr-region--desk .pt-hdr-regionbtn"), rpop = document.getElementById("pt-hdr-regionpop");
    function closeRegion() { if (rbtn && rpop) { hideEl(rpop); rbtn.setAttribute("aria-expanded", "false"); } }
    if (rbtn && rpop) {
      rbtn.addEventListener("click", function (e) { e.stopPropagation(); var open = rpop.hidden || rpop.classList.contains("pt-closing"); closeAll(); if (open) showEl(rpop); else hideEl(rpop); rbtn.setAttribute("aria-expanded", open ? "true" : "false"); });
    }

    /* ---- region rows: the form submit takes a moment, so the chosen row locks
       in at once (bold, paper, spinner), the others dim, and the pill relabels
       optimistically; the page then reloads in the new country ---- */
    document.addEventListener("click", function (e) {
      var row = e.target.closest && e.target.closest(".pt-hdr-regrow"); if (!row) return;
      var form = row.closest("form"); if (form) { form.classList.add("pt-busy"); form.querySelectorAll(".pt-hdr-regrow").forEach(function (r) { r.classList.remove("pt-on"); r.setAttribute("aria-current", "false"); }); }
      row.classList.add("pt-on", "pt-loading"); row.setAttribute("aria-busy", "true");
      var short = row.getAttribute("data-short");
      if (short) document.querySelectorAll(".pt-hdr-regionbtn").forEach(function (b) { var caret = b.querySelector(".pt-hdr-caret"); b.textContent = short; if (caret) b.appendChild(caret); b.classList.add("pt-loading"); });
    });

    /* ---- shop-by-phone columns ---- */
    var cols = [].slice.call(hdr.querySelectorAll(".pt-hdr-col--phones"));
    function fillCols(list) {
      cols.forEach(function (col) {
        var brand = col.getAttribute("data-brand") || "", box = col.querySelector(".pt-hdr-models");
        var rows = pick(list, brand, per);
        /* data-instant: the theme's instant.page prefetches links on hover, but skips
           query-string URLs unless told otherwise; these carry ?model= */
        box.innerHTML = rows.map(function (m) { return '<a href="' + esc(modelLink(m)) + '" data-instant>' + esc(shortName(m, brand)) + "</a>"; }).join("");
        box.removeAttribute("aria-busy");
      });
    }
    /* fetch when a panel is about to open (hover-intent or click), or on idle */
    var fetched = false;
    function ensureModels() { if (fetched) return; fetched = true; loadModels(function (list) { fillCols(list); fillMobile(list, currentBrand, currentQuery); }); }
    items.forEach(function (b) { b.addEventListener("mouseenter", ensureModels); b.addEventListener("focus", ensureModels); b.addEventListener("click", ensureModels); });
    if ("requestIdleCallback" in window) requestIdleCallback(ensureModels, { timeout: 4000 }); else setTimeout(ensureModels, 2500);

    /* ---- mobile sheet ---- */
    var burger = hdr.querySelector(".pt-hdr-burger"), sheet = document.getElementById("pt-mnav"), overlay = document.getElementById("pt-mnav-overlay");
    var closeBtn = sheet && sheet.querySelector(".pt-mnav-close");
    var mrbtn = sheet && sheet.querySelector(".pt-mnav-regionbtn"), mrpop = document.getElementById("pt-mnav-regionpop");
    var pills = sheet ? [].slice.call(sheet.querySelectorAll(".pt-mnav-pill")) : [];
    var mbox = sheet && sheet.querySelector(".pt-mnav-models"), mmore = sheet && sheet.querySelector(".pt-mnav-moremodels");
    var sbox = sheet && sheet.querySelector(".pt-mnav-search"), sinput = sheet && sheet.querySelector(".pt-mnav-sinput");
    function searchRows(list, q) {
      q = String(q || "").trim().toLowerCase(); if (!q) return [];
      var toks = q.split(/\s+/);
      /* four results at most (two rows of two): the box never grows, the
         fit-tool link below catches the long tail */
      return list.filter(function (m) { return (m.search || []).some(function (a) { return toks.every(function (t) { return a.indexOf(t) !== -1; }); }); }).slice(0, 4);
    }
    var currentBrand = pills.length ? pills[0].getAttribute("data-brand") : "", currentQuery = pills.length ? pills[0].getAttribute("data-query") : "";
    var sheetOpen = false, pushed = false, hideT = null;
    function fillMobile(list, brand, query) {
      if (!mbox) return;
      /* the "All other phones" pill carries no brand: a search field takes the
         place of the list (owner: use the empty space), results come from the
         same database; the fit-tool link below stays as the fallback */
      var other = brand === "";
      if (sbox) { sbox.hidden = false; sbox.classList.toggle("pt-hide", !other); }
      /* eight models (four rows of two) fill the box; the box height was sized for
         the search state and left a row empty under six */
      var rows = other ? searchRows(list, sinput ? sinput.value : "") : pick(list, brand, 8);
      /* search results show the model name without the brand so two columns fit */
      mbox.innerHTML = rows.map(function (m) { return '<a href="' + esc(modelLink(m)) + '" data-instant>' + esc(other ? (m.model || m.name) : shortName(m, brand)) + "</a>"; }).join("")
        + ((other && sinput && sinput.value.trim() && !rows.length) ? '<span class="pt-mnav-snone">' + esc(c.searchNone || "No match yet.") + "</span>" : "");

      if (mmore) {
        var noRows = !rows.length;
        mmore.textContent = ((other || noRows) ? (c.searchOther || "Search your phone in the fit tool") : (c.searchMore || "Search more phones")) + " →";
        /* the fit-tool link carries whatever was typed, so it opens the matcher prefilled */
        mmore.setAttribute("href", c.productUrl + "?findfit=" + encodeURIComponent((other && sinput && sinput.value.trim()) ? sinput.value.trim() : (query || "")));
      }
    }
    if (sinput) {
      var sT; sinput.addEventListener("input", function () { clearTimeout(sT); sT = setTimeout(function () { loadModels(function (list) { fillMobile(list, "", ""); }); }, 60); });
    }
    pills.forEach(function (p) {
      p.addEventListener("click", function () {
        if (p.classList.contains("pt-on")) return;
        pills.forEach(function (x) { x.classList.toggle("pt-on", x === p); x.setAttribute("aria-pressed", x === p ? "true" : "false"); });
        currentBrand = p.getAttribute("data-brand") || ""; currentQuery = p.getAttribute("data-query") || "";
        var swap = function () { loadModels(function (list) { fillMobile(list, currentBrand, currentQuery); if (mbox) mbox.classList.remove("pt-fade"); }); };
        if (reduced || !mbox) swap(); else { mbox.classList.add("pt-fade"); setTimeout(swap, 160); }
      });
    });
    function openSheet() {
      if (!sheet || sheetOpen) return;
      sheetOpen = true; clearTimeout(hideT);
      ensureModels();
      overlay.hidden = false; sheet.hidden = false;
      void sheet.offsetWidth;
      overlay.classList.add("pt-open"); sheet.classList.add("pt-open");
      document.documentElement.classList.add("pt-mnav-lock");
      burger.setAttribute("aria-expanded", "true");
      try { history.pushState({ ptnav: 1 }, ""); pushed = true; } catch (e) { pushed = false; }
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, reduced ? 0 : 320);
    }
    function closeSheet(fromPop) {
      if (!sheet || !sheetOpen) return;
      sheetOpen = false;
      overlay.classList.remove("pt-open"); sheet.classList.remove("pt-open");
      document.documentElement.classList.remove("pt-mnav-lock");
      burger.setAttribute("aria-expanded", "false");
      if (mrpop) { mrpop.classList.add("pt-hide"); if (mrbtn) mrbtn.setAttribute("aria-expanded", "false"); }
      var finish = function () { overlay.hidden = true; sheet.hidden = true; };
      if (reduced) finish(); else hideT = setTimeout(finish, 320);
      if (pushed && !fromPop) { pushed = false; try { history.back(); } catch (e) {} } else pushed = false;
      burger.focus();
    }
    window.ptOpenMobileNav = openSheet; window.ptCloseMobileNav = closeSheet;
    if (burger) burger.addEventListener("click", function () { sheetOpen ? closeSheet() : openSheet(); });
    if (closeBtn) closeBtn.addEventListener("click", function () { closeSheet(); });
    if (overlay) overlay.addEventListener("click", function () { closeSheet(); });
    window.addEventListener("popstate", function () { if (sheetOpen) closeSheet(true); });
    if (mrpop) { mrpop.hidden = false; mrpop.classList.add("pt-hide"); }
    if (mrbtn && mrpop) mrbtn.addEventListener("click", function () { var open = mrpop.classList.contains("pt-hide"); mrpop.classList.toggle("pt-hide", !open); mrbtn.setAttribute("aria-expanded", open ? "true" : "false"); });
    /* right-swipe to dismiss */
    if (sheet) {
      var sx = null, sy = null;
      sheet.addEventListener("touchstart", function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
      sheet.addEventListener("touchend", function (e) {
        if (sx == null) return; var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = Math.abs(t.clientY - sy); sx = sy = null;
        if (dx > 70 && dy < 60) closeSheet();
      }, { passive: true });
    }
    /* crossing the desktop breakpoint with the sheet open: close it */
    window.addEventListener("resize", function () { if (sheetOpen && window.innerWidth >= 900) closeSheet(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function () { var h = document.getElementById("site-header"); if (h) h.__ptInit = false; init(); });
})();
